import { createBrowserHistory, } from 'history'
import { isNull } from './index';
import { TOKEN_HASH, USER_HASH } from "./Constants";

const history = createBrowserHistory();

class Auth {
    login = (token = '') => {
        console.log(token)
        window.localStorage.setItem(TOKEN_HASH, token);
    }
    setUser = (user) => {
        window.localStorage.setItem(USER_HASH, JSON.stringify(user));
        window.user = user
    }

    logout = () => {
        window.localStorage.clear();
        history.replace('/');
        window.location.reload();
    }

    isAuthenticated = () => !isNull(window.localStorage.getItem(TOKEN_HASH));

    getStoredToken = () => window.localStorage[TOKEN_HASH];
    getStoredUser = () => JSON.parse(window.localStorage.getItem(USER_HASH));
}

export default new Auth();
